import React from 'react';
import Loader from './Loader';

const withLoader = WrappedComponent => {
  const withLoaderComponent = ({ isLoading, ...other }) => {
    if (isLoading) {
      return (<Loader />);
    } else
      return (<WrappedComponent {...other} />);
  };

  return withLoaderComponent;
};

export default withLoader;